import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { BsSpeedometer2, BsShieldCheck, BsGear } from 'react-icons/bs';
import './Sidebar.css';

const Sidebar: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="sidebar bg-dark text-white">
      <Nav className="flex-column">
        <div className="sidebar-header p-3">
          <h5 className="mb-0">Tableau de bord</h5>
        </div>
        <Nav.Item>
          <Nav.Link
            as={Link}
            to="/parametres"
            className={`sidebar-link ${isActive('/parametres') ? 'active' : ''}`}
          >
            <BsGear className="me-2" />
            Paramètres
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/dashboard"
            className={`sidebar-link ${isActive('/dashboard') ? 'active' : ''}`}
          >
            <BsSpeedometer2 className="me-2" />
            Accueil
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link 
            as={Link} 
            to="/sanctions"
            className={`sidebar-link ${isActive('/sanctions') ? 'active' : ''}`}
          >
            <BsShieldCheck className="me-2" />
            Sanctions
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
};

export default Sidebar;
